import { ref } from "vue";

const kpi_datasets = ref({});

const CreateFingerprint = (s) => {
    let hash = 0;
    for (let i = 0; i < s.length; i++) {
        const c = s.charCodeAt(i);
        hash = (hash << 5) - hash + c;
    }
    return Math.abs(hash).toString();
}

export {
    kpi_datasets,
    CreateFingerprint
}